// extracted by mini-css-extract-plugin
export default {"addButton":"ManagementTeam_addButton__lwA-F"};